export const EventParticipationRequestsQueryKeys = {
  all: ["event-participation-requests"] as const,
  event: (eventId: string) =>
    [...EventParticipationRequestsQueryKeys.all, eventId] as const,
};
